export default "/_nuxt/958e64bb478891913c9917bb1d73cf25.svg";